import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAuthToken, clearRefreshToken, getRefreshToken } from '@conext/auth';
import axiosClient from '../api/axiosClient';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const rt = getRefreshToken();
        if (rt) {
          await axiosClient.post('/auth/logout', { refresh_token: rt });
        }
      } catch (_) { /* logout best-effort */ }
      clearRefreshToken();
      clearAuthToken();
      navigate('/login', { replace: true });
    })();
  }, [navigate]);

  return (
    <div className="h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 flex items-center justify-center">
      <p className="text-gray-500 font-medium">Cerrando sesión...</p>
    </div>
  );
};

export default Logout;
